import { render, staticRenderFns } from "./PerformancesList.vue?vue&type=template&id=5d054bfa&scoped=true&"
import script from "./PerformancesList.vue?vue&type=script&lang=js&"
export * from "./PerformancesList.vue?vue&type=script&lang=js&"
import style0 from "./PerformancesList.vue?vue&type=style&index=0&id=5d054bfa&lang=scss&scoped=true&"
import style1 from "./PerformancesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d054bfa",
  null
  
)

export default component.exports